<template>
  <div class="fullHeight">
    <MypageSideMenu v-if="mobileAppHidden === false" :memberDropClose="true"/>
    <Card
        iconclass="icon-icon-reserve mypage-title-icon"
        :page_title="page_title"
    >
      <h5 class="font-weight-bold text-center mb-3 page-title">{{ page_title }}</h5>
      <div v-if="mobileAppDataDisplayFlag" class="w-100">
        <twoColumnTable :cellData="reserveNumber" />
        <table class="table table-striped mypage-reserve-table mypage-update-table">
            <tbody>
                <tr class="trFlex">
                    <td class="font-weight-bold">ゴルフ場名</td>
                    <td colspan="2" class="text-right text-sm-left">{{ reserveInfo.golf_name }}</td>
                </tr>
                <tr class="trFlex">
                    <td class="font-weight-bold td-btn-col">
                        <span>プレー日</span>
                        <span class="mypageframeupdatebutton float-right"><button class="bluebackbutton col-btn-size" @click="changePlayDate(reserveInfo)">変 更</button></span>
                    </td>
                    <td class="text-right text-sm-left align-middle">{{ dateFormated }}</td>
                </tr>
                <tr class="trFlex">
                    <td class="font-weight-bold td-btn-col">
                        <span>組数・人数</span>
                        <span class="mypageframeupdatebutton float-right"><button class="bluebackbutton col-btn-size" @click="OnUpdateClass()">変 更</button></span>
                    </td>
                    <td class="text-right text-sm-left align-middle">{{ reserveInfo.groupInfo.length }}組{{ reserveInfo.play_number }}人</td>
                </tr>
                <tr class="trFlex">
                    <td class="font-weight-bold td-btn-col">
                        <span>プラン名</span>
                        <span class="mypageframeupdatebutton float-right"><button class="bluebackbutton col-btn-size" @click="changePlan(reserveInfo)">変 更</button></span>
                    </td>
                    <td class="text-right text-sm-left align-middle">{{ reserveInfo.plan_name }}</td>
                </tr>
                <tr class="trFlex">
                    <td class="font-weight-bold">プレースタイル</td>
                    <td colspan="2 align-middle">
                        <Icon :iconFlg="reserveInfo.play_style" :dispType="'playStyle'" class="sp_play_style"/>
                    </td>
                </tr>
                <tr class="trFlex">
                    <td class="font-weight-bold td-btn-col">
                        <span>スタート時間</span>
                        <span class="mypageframeupdatebutton float-right"><button class="bluebackbutton col-btn-size" @click="changeStartTime(reserveInfo)">変 更</button></span>
                    </td>
                    <td class="text-right text-sm-left align-middle">
                        <span v-for="startTime in startTimeList" :key="startTime.id">
                            {{ startTime.courseName }}&nbsp;&nbsp;&nbsp;{{ startTime.playTimeReplace }}<br>
                        </span>
                    </td>
                </tr>
                <tr class="trFlex">
                    <td class="font-weight-bold td-btn-col">
                        <span>同伴者</span>
                        <span class="mypageframeupdatebutton float-right"><button class="bluebackbutton col-btn-size" @click="OnUpdateCompanion()">変 更</button></span>
                    </td>
                    <td class="text-right text-sm-left align-middle">
                        <div v-for="companion in companionList" :key="companion.id" class="text-left">
                            <span>{{ companion.cellNumber }}組目</span>
                            <span v-for="(player, index) in companion.player" :key="index" class="px-1">
                                {{ player }}
                            </span>
                        </div>
                    </td>
                </tr>
                <tr class="trFlex">
                <td class="font-weight-bold" valign="middle">プラン詳細</td>
                <td colspan="2" class="text-left align-middle">{{ reserveInfo.detail }}</td>
                </tr>
            </tbody>
        </table>
        <twoColumnTable :cellData="reserveNumberTableInfo" />
      </div>
      <div v-else class="w-100 text-center mb-2">{{ mobileAppDisplayText }}</div>
      <!-- 一覧へ戻るボタン追加 -->
      <template v-slot:listBackBtn>
        <div v-if="mobileAppHidden === false" class="row row-notMx">
            <div class="col-lg-3 ml-md-auto mr-md-auto text-center py-2">
                <button
                    type="button"
                    class="mypagebackbutton footer-btn-size"
                    @click="BackReserveList">
                一覧へ戻る</button>
            </div>
        </div>
      </template>
    </Card>
    <MypageMenuFooter v-if="mobileAppHidden === false" />
  </div>
</template>

<script>
import MypageSideMenu from './MypageSideMenu';
import Card from '../components/Card';
import twoColumnTable from '../components/twoColumnTable';
import Icon from '../components/Icon';
import {
    GET_RESERVE,
    GET_MAX_RESERVE_BRANCH_NO } from '../../constants/mypage_reserves';
// import { GET_CODE_LIST } from '../../constants/codelist';
import { CODE_MASTER } from '../../config';
import validater from "../../lib/validater";
import MypageMenuFooter from './MypageMenuFooter';

export default {
    components: {
        Card,
        Icon,
        MypageSideMenu,
        MypageMenuFooter,
        twoColumnTable,
        validater
    },
    data () {
        return {
            reserveNo: '',
            member_no: '',
            page_title: '予約内容変更',
            golf_group_code: process.env.MIX_GROUP_CODE,
            confirmDialog: false,
            playNumserSelection: [],
            // options: ['1','2','3','4'],
            // 人数入力用の変数
            input: {
                playNumber: '',
                oldPlayNumber: '',
                cellNumber: '',
                oldCellNumber: ''
            },
            // 予約情報配列
            reserveInfo: {
                reserve_no: '',
                reserve_type: '',
                golf_code: '',
                golf_name: '',
                telephone: '',
                total_fee: '',
                plan_id: '',
                status: '',
                play_date: '',
                play_number: '',
                plan_name: '',
                play_start: '',
                player_min: '',
                v: '',
                cancel_detail: '',
                course_name: '',
                detail: '',
                play_style: '',
                player_left: '',
                member_class: '',
                open_flag: '',
                plan_member_class: '',
                groupInfo: {}
            },
            startTimeList: [],
            // plan_idが0なら電話予約：予約内容を変更できないようにする
            planId: 0,
            // CodeMaster配列（中身は空）
            reserve_situation: {},
            companionList: [],
            memberClass: '',
            openFlag: '',
            planMemberClass: '',
            // モバイルアプリデータ表示フラグ
            mobileAppDataDisplayFlag: false,
            // モバイルアプリデータ非表示テキスト
            mobileAppDisplayText: '',
            // モバイルアプリ非表示フラグ
            mobileAppHidden: false
        };
    },
    async created () {
        // モバイルアプリか判断する
        if (this.$store.state.auth.mobileAppFlag) {
            // モバイルアプリの場合、サイドメニュー、フッター、遷移ボタンを非表示にする
            this.mobileAppHidden = true;
        }
        if (this.$store.state.auth.mobileAppReserveNo) {
            this.reserveNo = this.$store.state.auth.mobileAppReserveNo;
        } else {
            if (sessionStorage.getItem('storageReserveNo')) {
                const strageData = JSON.parse(sessionStorage.getItem('storageReserveNo'));
                this.reserveNo = strageData.mypage.reserveNo;
            }
        }
        // this.reserve_situation = await this.getCodeList('reserve_situation');
        // this.playNumserSelection = await this.getCodeList('play_number');
        this.getReserve();
        sessionStorage.removeItem('Reserve.cellAdd');
    },
    beforeRouteLeave (to, from, next) {
        this.$store.commit("mypage/pushReserveNo", 0);
        this.$store.commit("mypage/pushPlanName", '');
        const strageData = sessionStorage.removeItem('storageReserveNo');
        next();
    },
    computed: {
        dateFormated () {
            const date = this.reserveInfo.play_date.split('-');
            return date[0] + '年' + date[1] + '月' + date[2] + '日';
        },
        timeFormated () {
            const time = this.reserveInfo.play_start.split(':');
            return time[0] + '時' + time[1] + '分';
        },
        reserveNumber () {
            return [
                { name: '予約番号', value: this.reserveInfo.reserve_no, class: 'text-right text-sm-left' }
            ];
        },
        reserveNumberTableInfo () {
            return [
                { name: 'お一人様料金', value: `￥${this.reserveInfo.total_fee.toLocaleString()}(総額)`, class: 'text-right text-sm-left' },
                { name: 'キャンセル規定', value: this.reserveInfo.cancel_detail}
            ];
        }
    },
    methods: {
        /** ----------------------------------------------
         * 予約情報を取得
         * mypage_reserve_flag: モバイルアプリ予約表示フラグ（1: 予約詳細 2: 予約変更）
         * ログインユーザーが予約同伴者の場合に、必要なデータを取得するか判断します。
         * 予約詳細の場合: ログインユーザーが代表者、同伴者に関わらず取得します。
         * 予約変更の場合: ログインユーザーが代表者のみ取得、同伴者は変更不可の為、非表示。
         * ----------------------------------------------------------------------- */
        getReserve () {
            sessionStorage.removeItem('Reserve.prevUrl');
            sessionStorage.removeItem('MyPage.reserveBranchNo');
            if (!this.reserveNo) {
                if (sessionStorage.getItem("MyPage.reserveNo")) {
                    this.reserveNo = sessionStorage.getItem("MyPage.reserveNo");
                } else {
                    this.reserveNo = sessionStorage.getItem('Reserve.reserveNo');
                }
            }
            this.$apollo.query({
                query: GET_RESERVE,
                fetchPolicy: 'no-cache',
                variables: {
                  reserve_no: this.reserveNo,
                  mypage_reserve_flag: 2
                }
            }).then(res => {
                const data = res.data.GetReserveDetail.Reserve;
                if (data === null) {
                    this.mobileAppDataDisplayFlag = false;
                    this.mobileAppDisplayText = '変更可能なデータがありません。予約番号 : ' + this.reserveNo;
                } else {
                    this.mobileAppDataDisplayFlag = true;
                    Object.keys(this.reserveInfo).forEach(el => {
                        this.$set(this.reserveInfo, el, data[el])
                    });
                    this.planId = Number(this.reserveInfo.plan_id);
                    this.input.oldPlayNumber = this.reserveInfo.play_number;
                    this.input.playNumber = this.reserveInfo.play_number;
                    this.input.oldCellNumber = this.reserveInfo.groupInfo.length;
                    this.input.cellNumber = this.reserveInfo.groupInfo.length;
                    this.openFlag = this.reserveInfo.open_flag;
                    this.planMemberClass = this.reserveInfo.plan_member_class;
                    this.memberClass = this.reserveInfo.member_class;
                    this.startTimeList = [];
                    // let count = 0;
                    Object.keys(this.reserveInfo.groupInfo).forEach(key => {
                        const time = this.reserveInfo.groupInfo[key].play_start.split(':');
                        var timeSplit = time[0] + '時' + time[1] + '分';
                        var tempCell = {};
                        // count++;
                        tempCell["id"] = key;
                        tempCell["courseName"] = this.reserveInfo.groupInfo[key].course_name;
                        tempCell["playTimeReplace"] = timeSplit;
                        this.startTimeList.push(tempCell);
                        // 同伴者情報整形
                        var companionCell = {};
                        companionCell["id"] = key;
                        companionCell["cellNumber"] = Number(key) + 1;
                        companionCell["player"] = [];
                        var member = this.reserveInfo.groupInfo[key].member;
                        if (member !== null) {
                            companionCell["player"] = member.filter(data => data != ' ');
                        }
                        this.companionList.push(companionCell);
                    });
                }
            }).catch(error => {
                if (this.$store.state.auth.mobileAppFlag) {
                    this.mobileAppDataDisplayFlag = false;
                    this.mobileAppDisplayText = '変更可能なデータがありません。予約番号 : ' + this.reserveNo;
                } else {
                    this.$router.push({ path: '/mypage-reserve-list' });
                }
                this.error = error;
            })
        },
        /** ----------------------------------------------
         * 最大の予約枝番を取得
         * ---------------------------------------------- */
        checkMaxReserveBranchNo: async function () {
            try {
                let res = await this.$apollo.query({
                    fetchPolicy: 'no-cache',
                    query: GET_MAX_RESERVE_BRANCH_NO,
                    variables: {
                        reserve_no: this.reserveNo
                    }
                });
                const data = res.data.GetReserveBranchNo.reserve_branch_no;
                sessionStorage.setItem("MyPage.reserveBranchNo", data);
            } catch (error) {
                this.error = error;
            }
        },
        BackReserveList (){
            // 予約照会画面へ遷移
            this.$router.push({ path: '/mypage-reserve-list' });
        },
        BackMyPage (){
            // マイページへ遷移
            this.$router.push({ path: '/mypage' });
        },
        // /** ----------------------------------------------
        //  * 予約状況オブジェクトを取得
        //  * ---------------------------------------------- */
        // getCodeList (codeKey) {
        //     return this.$apollo.query({
        //         query: GET_CODE_LIST,
        //         variables: {
        //             code_key: codeKey,
        //             default_display: 0
        //         }
        //     }).then(res => {
        //         const data = res.data.GetCodeList.CodeList;
        //         return data;
        //     });
        // },
        /** ----------------------------------------------
         * プラン変更
         * ---------------------------------------------- */
        changePlan (reserveInfo){
            // マイページへ遷移
            sessionStorage.setItem('Reserve.groupInfo', JSON.stringify(this.reserveInfo.groupInfo));
            sessionStorage.setItem("MyPage.returnBackUrl", "/mypage-reserve-update");
            sessionStorage.setItem("MyPage.reserveNo", this.reserveNo);
            sessionStorage.setItem("MyPage.golfCode", reserveInfo.golf_code);

            this.$router.push({ path: '/reserve' });
        },
        /** ----------------------------------------------
         * プレー日変更
         * ---------------------------------------------- */
        changePlayDate (reserveInfo){
            sessionStorage.removeItem('Reserve.groupInfo');
            sessionStorage.setItem("MyPage.returnBackUrl", "/mypage-reserve-update");
            sessionStorage.setItem("MyPage.reserveNo", this.reserveNo);
            sessionStorage.setItem("MyPage.golfCode", reserveInfo.golf_code);
            // マイページへ遷移
            this.$router.push({ path: '/reserve' });
        },
        /** ----------------------------------------------
         * スタート時間変更
         * ---------------------------------------------- */
        changeStartTime (reserveInfo){
            // 時間選択画面で、セッションのデータの有無で予約の変更か新規予約か判断する為、通常とシェア予約の時にreserveInfoにデータを保存する
            if (this.reserveInfo.reserve_type == CODE_MASTER.RESERVE_TYPE_NORMAL || this.reserveInfo.reserve_type == CODE_MASTER.RESERVE_TYPE_SHARE) {
                sessionStorage.setItem('Reserve.groupInfo', JSON.stringify(this.reserveInfo.groupInfo));
            } else {
                sessionStorage.removeItem('Reserve.groupInfo');
            }
            sessionStorage.setItem('Reserve.cellNumber', Number(this.input.cellNumber));
            sessionStorage.setItem("MyPage.returnBackUrl", "/mypage-reserve-update");
            sessionStorage.setItem("MyPage.reserveNo", this.reserveNo);
            sessionStorage.setItem("MyPage.golfCode", reserveInfo.golf_code);
            sessionStorage.setItem('Reserve.clickPage','/mypage-reserve-update');
            // スタート時間変更の場合はcompanionChangeFlgを3とする
            sessionStorage.setItem('MyPage.companionChangeFlg', 3);
            sessionStorage.setItem('MyPage.memberClass', this.memberClass);
            // マイページへ遷移
            this.$router.push({ path: '/starttime' });
        },
        /** ----------------------------------------------
         * 同伴者登録画面表示（同伴者変更及び人数変更）
         * ---------------------------------------------- */
        OnUpdateCompanion: async function() {
            await this.checkMaxReserveBranchNo();
            sessionStorage.setItem('MyPage.reserveNo', this.reserveNo);
            sessionStorage.setItem('Reserve.reserveNo', this.reserveNo);
            sessionStorage.setItem('Reserve.reserveType',this.reserveInfo.play_style.reserve_type);
            sessionStorage.setItem('MyPage.returnBackUrl', "/mypage-reserve-update");
            //sessionStorage.setItem('MyPage.reserveNumber', Number(playNumber));
            // マイページ人数選択画面からの変更の場合
            sessionStorage.setItem('MyPage.companionChangeFlg', 1);
            this.$router.push({ path: "/companion-list" });
        },
        /** ----------------------------------------------
         * 同伴者登録画面表示（組数変更）
         * ---------------------------------------------- */
        OnUpdateClass: async function() {
            await this.checkMaxReserveBranchNo();
            sessionStorage.setItem('MyPage.reserveNo', this.reserveNo);
            sessionStorage.setItem('Reserve.reserveNo', this.reserveNo);
            sessionStorage.setItem('Reserve.reserveType',this.reserveInfo.play_style.reserve_type);
            sessionStorage.setItem('MyPage.returnBackUrl', "/mypage-reserve-update");
            sessionStorage.setItem('Reserve.clickPage', "/mypage-reserve-update");
            //sessionStorage.setItem('MyPage.reserveNumber', Number(playNumber));
            // マイページ人数選択画面からの変更の場合
            sessionStorage.setItem('MyPage.companionChangeFlg', 2);
            sessionStorage.setItem('MyPage.openFlag', this.openFlag);
            sessionStorage.setItem('MyPage.planMemberClass', this.planMemberClass);
            sessionStorage.setItem('MyPage.memberClass', this.memberClass);
            this.$router.push({ path: "/registcompanion" });
        }
    }
}

</script>


<style scoped>
/* 予約内容変更見出し */
h5 {
    width: 100%;
    display: block
}
.form-width{
    width: 30% !important;
}
table > tbody > tr > td {
    overflow-wrap: break-word;
    word-break: break-word;
}
.sp_play_style {
    justify-content: flex-start;
    display: flex;
    align-items: center;
}
@media screen and (max-width: 896px) {
    .sp_play_style {
        justify-content: flex-end;
    }
    .page-title {
        margin-top: 1rem;
    }
}
@media screen and (max-width: 575px) {
  .mypageframeupdatebutton {
    width: 25%;
  }
}
</style>
